<!-- 价格策略分组操作 -->
<template>
	<div>
		<subComponents  ref="showSelectData"></subComponents>
		<el-dialog :visible.sync="dataActionBox.showStatus" :title="dataActionBox.boxTitle"  append-to-body :close-on-click-modal="false" center  width="50%" top="2rem">
			<el-form size="mini" label-position="right" label-width="200px">
				<el-form-item label="价格策略分组名称">
					<el-input v-model.trim="sendDataInfo.prgGname" :maxlength="$store.state.inputLength"></el-input>
				</el-form-item>
				<el-form-item label="价格策略分组状态">
					<el-radio-group v-model="sendDataInfo.prgState" >
					    <el-radio-button :label="0">停用</el-radio-button>
					    <el-radio-button :label="1">启用</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="下属客户分组列表">
					<div style="margin:.2rem 0">
						<el-button type="success"    @click="$refs['showSelectData'].openBox('customerGroupList','customerGroupList','cmgroupId')">新增客户分组</el-button>
					</div>
					<el-table :data="sendDataInfo.cmgroupList"  height="280"   border  style="width: 100%">
						<el-table-column label="操作" width="80">
							<template  slot-scope="scope">
								<el-button type="primary" @click="delListInfo(scope.$index)">删除</el-button>
							</template>
						</el-table-column>
					    <el-table-column  prop="cmgroupName" label="客户分组名称">
					    </el-table-column>
					</el-table>
				</el-form-item>
			
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dataActionBox.showStatus = false">取消</el-button>
				<el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==0">保存</el-button>
				<el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==1">保存</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
	name:'priceStrategyGroupAction',
	props:[],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
			dataActionBox:{
				showStatus:false,
				boxTitle:'新增'||'编辑',
				actionType:0, // 0新增，1修改
			},
			sendDataInfo:{
				cmgroupIds: [],
				prgGname: "",
				prgState:0,
				cmgroupList:[],
			},
			
        };
    },
    //监听属性 类似于data概念
    computed: {
	},
    //监控data中的数据变化
    watch: {
	},
    //方法集合
    methods: {
		delListInfo(index){
			this.sendDataInfo.cmgroupList.splice(index,1)
		},
	
		initActionBox(){
			for(let key in this.sendDataInfo){
				this.sendDataInfo[key]  = ''
			}
			this.sendDataInfo.prgState = 0;
			this.sendDataInfo.cmgroupIds = [];
			this.sendDataInfo.cmgroupList = [];
			
		},
		
		isShowData(name,value){
			switch(name){
				case 'customerGroupList':
					var dataInfo = sessionStorage.getItem('selectCustomerGroupData')
					if(dataInfo){
						dataInfo = JSON.parse(dataInfo)
						var isPushData = true
						this.sendDataInfo.cmgroupList.forEach((item,keys)=>{
							if(item.cmgroupId == dataInfo.cmgroupId){
								this.$message({
									message: '客户分组已存在，请勿重复添加',
									type: 'error'
								});
								isPushData = false
								return false
							}
						})
						if(isPushData==true){
							this.sendDataInfo.cmgroupList.push(dataInfo)
						}
					}
					
				break;
				default:
					this.sendDataInfo[name] = value
				
			}
		},
		
	
		
		openBox(cate,oldData=''){
			this.initActionBox()
			if(cate == 0){
				this.dataActionBox.boxTitle = '新增价格策略分组'
			}else{
				this.dataActionBox.boxTitle = '编辑价格策略分组'
				this.sendDataInfo  = oldData
				this.sendDataInfo.cmgroupIds   = []
			
			}
			this.dataActionBox.actionType = cate
			this.dataActionBox.showStatus = true
			
		},
		async sendDataAction(){
			if(this.sendDataInfo.prgGname==''){
				this.$message({
					message: '请填写价格策略名称',
					type: 'error'
				});
				return false
			}
			if( this.dataActionBox.actionType==0 && this.sendDataInfo.cmgroupList.length<=0){
				this.$message({
					message: '请选择客户分组',
					type: 'error'
				});
				return false
			}
			
			var newSendDataInfo = JSON.parse(JSON.stringify(this.sendDataInfo))
			newSendDataInfo.cmgroupList.forEach((item,keys)=>{
				newSendDataInfo.cmgroupIds.push(item.cmgroupId)
			})
			if(this.dataActionBox.actionType==0){
				var responseData =  await this.$http.addPriceStrategyGroup(newSendDataInfo)
			}else{
				var responseData =  await this.$http.setPriceStrategyGroup(newSendDataInfo)
			}
			
			
			if(responseData.status == 200){
				this.dataActionBox.showStatus = false
				this.$message({
					message: '操作成功',
					type: 'success'
				});
				this.$parent.getDataList()
				
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
	
		
		
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
	}, //生命周期 - 创建之前
    beforeMount() {
	}, //生命周期 - 挂载之前
    beforeUpdate() {
	}, //生命周期 - 更新之前
    updated() {
	}, //生命周期 - 更新之后
    beforeDestroy() {
	}, //生命周期 - 销毁之前
    destroyed() {
	}, //生命周期 - 销毁完成
    activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>